import axios from 'axios';

/**
 * Retrieve winners data from API
 * @param {string} userLanguage - Language parameter for API call
 * @returns {Promise} API response with winners data
 */
export const retrieveWinners = async (userLanguage = 'EN') => {
  const response = await axios({
    url: `api/getWinnersData?lang=${ userLanguage }`,
    method: 'GET',
  });

  return {
    data: response.data.data,
    lastUpdated: response.data.lastUpdated || new Date().toISOString(),
  };

};
